module.exports = __webpack_public_path__ + "img/put-chart.5bdf1225.svg";